import { NODE_ENV } from '@com/config/env'

const mindworksInteractiveAdsList = {
  development:
    'https://mmp-portal-dev.s3.cn-north-1.amazonaws.com.cn/mindworks-interactive-ads.html',
  test: 'http://mmp-portal-test.s3.amazonaws.com/mindworks-interactive-ads.html',
  production: 'https://mmp-cdn.rayjump.com/mindworks-interactive-ads.html',
  prerelease: 'https://mmp-cdn.rayjump.com/mindworks-interactive-ads.html',
}

export const mindworksInteractiveAdsUrl: string =
  mindworksInteractiveAdsList[
    NODE_ENV as keyof typeof mindworksInteractiveAdsList
  ]
